import * as Actions from "./constants";

const initialState = {
    userList: [],
    createUserSuccess: false,
    createUserError: false,
};

export default function userReducer(state = initialState, action) {
    switch (action.type) {
        case Actions.CREATE_USER:
            return {
                ...state,
                createUserSuccess: false,
                    createUserError: false,
            };
        case Actions.CREATE_USER_SUCCESS:
            return {
                ...state,
                createUserSuccess: true,
                    createUserError: false,
            };
        case Actions.CREATE_USER_ERROR:
            return {
                ...state,
                createUserSuccess: false,
                    error: action.error,
                    createUserError: true,
            };
        default:
            return state;
    }
}
